/**
 * Placeholder row id aligned with backend populateRowIdsToAttrs:
 * negative rowId ? savedIds[-(rowId) - 1] (i.e. array index).
 *
 * Do not use minId-1: with existing positive ids that yields -1 and binds
 * Adjustment attrs to the first saved row after Add Row.
 */
export function placeholderRowIdAtIndex(index: number): number {
    return -(Math.max(0, index) + 1);
}

/** Id for a new row appended at the end of `rows`. */
export function placeholderRowIdForAppend(rowCount: number): number {
    return placeholderRowIdAtIndex(rowCount);
}
